import { FiHeart } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { toggleFavoriteLocal, toggleFavoriteInFirestore } from "../../Features/Favorite/favoritesSlice";
import { useAuth } from "../../Auth/AuthContext copy";
import { useState } from "react";
import Loogin from "../Authentication/Login/Login";
import AlertVerifyEmail from '../../Components/Verify/verify_alert';

const FavoriteButton = ({ productId }) => {
  const dispatch = useDispatch();
  const { currentUser, setModal } = useAuth();
  const [showAlert, setShowAlert] = useState(false);
  const favorites = useSelector((state) => state.favorites.favoriteProducts);
  const isFavorite = favorites.includes(productId);

  const openLogin = () => {
    setModal({ isOpen: true, title: 'Login', content: <Loogin /> });
  };

  const closeAlert = () => {
    setShowAlert(false);
  };

  const handleFavoriteToggle = () => {
    if (!currentUser) {
      openLogin();
    } else if (!currentUser.emailVerified) {
      setShowAlert(true);
    } else {
      dispatch(toggleFavoriteLocal(productId));
      dispatch(toggleFavoriteInFirestore({ userId: currentUser.uid, productId, isFavorite }));
    }
  };

  return (
    <>
      {showAlert && <AlertVerifyEmail closeAlert={closeAlert} />}
      <FiHeart
        onClick={handleFavoriteToggle}
        style={{
          color: isFavorite ? "red" : "#767676",
          cursor: "pointer",
        }}
        size={20}
      />
    </>
  );
};

export default FavoriteButton;
